import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\" id=\"icon-login\"><path d=\"M11 11.5c5.52 0 10 2.093 10 4.667V19.5H1v-3.333C1 13.593 5.48 11.5 11 11.5Zm8.667 4.667c0-1.84-3.88-3.334-8.667-3.334s-8.667 1.494-8.667 3.334v2h17.334v-2ZM11 .5a4.666 4.666 0 1 1 0 9.333A4.666 4.666 0 0 1 11 .5Zm0 1.333A3.333 3.333 0 1 0 11 8.5a3.333 3.333 0 0 0 0-6.667Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol